import { all, call, put, takeLatest } from 'redux-saga/effects';
import { requestResetAct } from './actions';
import { requestPasswordResetApi } from '../../api/auth.api';
import { addMessage } from '../ToastMessagesManager/actions';
import { getErrorMessage } from '../../utils/error.util';

// import { DEFAULT_ACTION } from './constants';

function* requestPasswordReset({ payload }) {
  const { loadingState, data: payloadData } = payload;
  if (loadingState === 1) {
    try {
      const data = yield call(requestPasswordResetApi, payloadData);
      if (data) {
        yield all([
          put(requestResetAct(2, payloadData)),
          put(
            addMessage({
              message: `If an account with this email exists, you’ll receive a reset link.`,
              variant: 'success',
            }),
          ),
        ]);
      } else {
        throw new Error('Unable to process the request, please try again');
      }
    } catch (error) {
      const errMessage = getErrorMessage(error);
      yield all([
        put(requestResetAct(3, payloadData)),
        put(
          addMessage({
            message: errMessage,
            variant: 'error',
          }),
        ),
      ]);
    }
  }
}

// Individual exports for testing
export default function* forgotPasswordSaga() {
  yield takeLatest(requestResetAct.toString(), requestPasswordReset);
}
